/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Flex } from "frontend/src/components/Layout"
import { Logo } from "frontend/src/components/Logo"
import { CMSLink } from "frontend/src/components/CMSLink"
import { Line } from "./Line"
import { Fragment } from "react"

function LinkColumn({ column: { links, showOnMobile } }) {
  return (
    <div
      sx={{
        flex: 1,
        minWidth: 220,
        display: showOnMobile ? ["block", "block", "none"] : ["none", "none", "block"],
        mb: [0, 0, 4],
      }}
    >
      <Flex.column>
        {links.map(link => (
          <Fragment key={link._key}>
            <CMSLink
              link={link}
              sx={{
                variant: "text.subtitle2",
                color: "white",
                textDecoration: "none",
              }}
            />
            <Line sx={{ display: ["block", "block", "none"] }} />
          </Fragment>
        ))}
      </Flex.column>
    </div>
  )
}

function LogoColumn({ column: { headline, logos, largeLogos } }) {
  return (
    <div sx={{ flex: 1, minWidth: 220, mb: [0, 0, 4] }}>
      <Flex
        justify="space-between"
        align={["center", "center", "flex-start"]}
        direction={["row", "row", "column"]}
        wrap
        sx={{ my: 3 }}
      >
        <h3
          sx={{
            variant: "text.body1",
            textTransform: "uppercase",
            color: "white",
            lineHeight: "heading",
          }}
        >
          {headline}
        </h3>
        <Flex.row wrap sx={{ mt: largeLogos ? [0, 0, 4] : [0, 0, 3] }}>
          {logos.map(({ logo, link }) => (
            <CMSLink link={link} key={logo}>
              <Logo
                name={logo}
                sx={{ mr: 4, my: largeLogos ? 0 : 4 }}
                height={largeLogos ? [30, 30, 34] : [18, 18, 22]}
                forceColor="white"
              />
            </CMSLink>
          ))}
        </Flex.row>
      </Flex>
    </div>
  )
}

export { LinkColumn, LogoColumn }
